import { render, staticRenderFns } from "./CompetitionRegistrationInput.vue?vue&type=template&id=55c96493&scoped=true"
import script from "./CompetitionRegistrationInput.vue?vue&type=script&lang=js"
export * from "./CompetitionRegistrationInput.vue?vue&type=script&lang=js"
import style1 from "./CompetitionRegistrationInput.vue?vue&type=style&index=1&id=55c96493&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c96493",
  null
  
)

export default component.exports